<template>
  <rect
    :x="getExtendX"
    :y=0
    :width="1"
    :height="getPipeEditorHeight"
    opacity=".85"
    fill="green"
  />
  <rect
    :x="getExtendX"
    :y="0"
    :width="Math.max(getExtendW * getMagScale, 0)"
    :height="getExtendH"
    opacity=".85"
    fill="green"
    @click.stop="handleExtendClick"
    @contextmenu.stop=""
    class="extend-area"
  />
  <text
    :x="getExtendX + 10"
    :y=" 18"
    class="extend-text"
  >
    EXTEND
  </text>
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';

export default {
  name: 'Extend',
  mounted () {
    useSegmentStore().setExtendFunc(this.handleExtendClick);
  },
  computed: {
    getAllPipesLength () {
      return useSegmentStore().getAllSegmentLengths('pipe');
    },
    getAllSlopesLength () {
      return useSegmentStore().getAllSegmentLengths('slope');
    },
    getPipeEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getExtendX () {
      return (this.getAllPipesLength * this.getMagScale) + useInputStore().getXAxisGap;
    },
    getExtendW () {
      return this.getAllSlopesLength - this.getAllPipesLength;
    },
    getExtendH () {
      return 30;
    },
  },
  methods: {
    handleExtendClick () {
      useSegmentStore().extendPipes();
      useInputStore().sprinklerCalc();
    }
  }
};
</script>

<style scoped>
.extend-text {
  font-family: "Heebo", sans-serif;
  font-size: 65%;
  font-weight: bold;
  user-select: none;
  pointer-events: none;
  fill: white;
}
.extend-area {
  cursor:pointer;
}
</style>